// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-screen {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-lg);
}

.login-container {
  margin-top: var(--space-6xl);
}

@media (min-width: 580px ) { /* 768px */
  .login-container {
    padding: 3.125rem 6.25rem 0 6.25rem;
  }
}

/* Logo Section */
.logo-section {
  margin-bottom: var(--space-2xl);
  text-align: center;
}

.logo-image {
  width: 5.75rem; /* 92px */
  height: 2.375rem; /* 38px */
  object-fit: contain;
}

/* Responsive logo sizing */
@media (min-width: 48rem) { /* 768px */
  .logo-image {
    width: 6.875rem; /* 110px */
    height: 2.875rem; /* 46px */
  }
}

@media (min-width: 64rem) { /* 1024px */
  .logo-image {
    width: 8rem; /* 128px */
    height: 3.375rem; /* 54px */
  }
}

@media (min-width: 90rem) { /* 1440px */
  .logo-image {
    width: 9.375rem; /* 150px */
    height: 3.9375rem; /* 63px */
  }
}

/* Welcome Section */
.welcome-section {
  text-align: center;
  margin-bottom: var(--space-2xl);
}

.welcome-title {
  font-size: 2.275rem; /* 35px */
  font-weight: 600;
  font-style: normal;
  line-height: 104%;
  letter-spacing: -0.04em;
  color: var(--color-secondary);
  margin: 0 0 var(--space-md) 0;
}

/* Responsive welcome title sizing */
@media (min-width: 48rem) { /* 768px */
  .welcome-title {
    font-size: 2.5rem; /* 40px */
  }
}

@media (min-width: 64rem) { /* 1024px */
  .welcome-title {
    font-size: 2.875rem; /* 46px */
  }
}

@media (min-width: 90rem) { /* 1440px */
  .welcome-title {
    font-size: 3.375rem; /* 54px */
  }
}

.welcome-subtitle {
  font-size: 1.1rem; /* 16px */
  font-weight: 300 !important;
  font-style: normal;
  line-height: 115%;
  text-align: center;
  color: var(--color-secondary);
  margin: 0;
}

/* Responsive welcome subtitle sizing */
@media (min-width: 48rem) { /* 768px */
  .welcome-subtitle {
    font-size: 1.125rem; /* 18px */
  }
}

@media (min-width: 64rem) { /* 1024px */
  .welcome-subtitle {
    font-size: 1.25rem; /* 20px */
  }
}

@media (min-width: 90rem) { /* 1440px */
  .welcome-subtitle {
    font-size: 1.375rem; /* 22px */
  }
}

/* Login Form Card */
.login-form-card {
  width: 100%;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: var(--space-lg);
}

/* Login Button */
.login-button {
  width: 100%;
  margin-top: var(--space-sm);
}

/* Forgot Password */
.forgot-password {
  text-align: center;
  margin-top: var(--space-sm);
}

.forgot-password-link {
  font-size: var(--font-size-base);
  font-weight: 500;
  font-style: normal;
  line-height: 140%;
  letter-spacing: 0.03em;
  text-align: right;
  vertical-align: middle;
  color: var(--color-secondary-text);
  text-decoration: none;
  transition: color 0.2s ease;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

.forgot-password-link:hover {
  color: var(--color-primary);
  text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login/LoginScreen.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,6BAA6B,UAAU;EACrC;IACE,mCAAmC;EACrC;AACF;;AAEA,iBAAiB;AACjB;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,cAAc,EAAE,SAAS;EACzB,gBAAgB,EAAE,SAAS;EAC3B,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B,4BAA4B,UAAU;EACpC;IACE,eAAe,EAAE,UAAU;IAC3B,gBAAgB,EAAE,SAAS;EAC7B;AACF;;AAEA,4BAA4B,WAAW;EACrC;IACE,WAAW,EAAE,UAAU;IACvB,gBAAgB,EAAE,SAAS;EAC7B;AACF;;AAEA,4BAA4B,WAAW;EACrC;IACE,eAAe,EAAE,UAAU;IAC3B,iBAAiB,EAAE,SAAS;EAC9B;AACF;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB,EAAE,SAAS;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA,oCAAoC;AACpC,4BAA4B,UAAU;EACpC;IACE,iBAAiB,EAAE,SAAS;EAC9B;AACF;;AAEA,4BAA4B,WAAW;EACrC;IACE,mBAAmB,EAAE,SAAS;EAChC;AACF;;AAEA,4BAA4B,WAAW;EACrC;IACE,mBAAmB,EAAE,SAAS;EAChC;AACF;;AAEA;EACE,iBAAiB,EAAE,SAAS;EAC5B,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,SAAS;AACX;;AAEA,uCAAuC;AACvC,4BAA4B,UAAU;EACpC;IACE,mBAAmB,EAAE,SAAS;EAChC;AACF;;AAEA,4BAA4B,WAAW;EACrC;IACE,kBAAkB,EAAE,SAAS;EAC/B;AACF;;AAEA,4BAA4B,WAAW;EACrC;IACE,mBAAmB,EAAE,SAAS;EAChC;AACF;;AAEA,oBAAoB;AACpB;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,kCAAkC;EAClC,qBAAqB;EACrB,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB","sourcesContent":[".login-screen {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-lg);\n}\n\n.login-container {\n  margin-top: var(--space-6xl);\n}\n\n@media (min-width: 580px ) { /* 768px */\n  .login-container {\n    padding: 3.125rem 6.25rem 0 6.25rem;\n  }\n}\n\n/* Logo Section */\n.logo-section {\n  margin-bottom: var(--space-2xl);\n  text-align: center;\n}\n\n.logo-image {\n  width: 5.75rem; /* 92px */\n  height: 2.375rem; /* 38px */\n  object-fit: contain;\n}\n\n/* Responsive logo sizing */\n@media (min-width: 48rem) { /* 768px */\n  .logo-image {\n    width: 6.875rem; /* 110px */\n    height: 2.875rem; /* 46px */\n  }\n}\n\n@media (min-width: 64rem) { /* 1024px */\n  .logo-image {\n    width: 8rem; /* 128px */\n    height: 3.375rem; /* 54px */\n  }\n}\n\n@media (min-width: 90rem) { /* 1440px */\n  .logo-image {\n    width: 9.375rem; /* 150px */\n    height: 3.9375rem; /* 63px */\n  }\n}\n\n/* Welcome Section */\n.welcome-section {\n  text-align: center;\n  margin-bottom: var(--space-2xl);\n}\n\n.welcome-title {\n  font-size: 2.275rem; /* 35px */\n  font-weight: 600;\n  font-style: normal;\n  line-height: 104%;\n  letter-spacing: -0.04em;\n  color: var(--color-secondary);\n  margin: 0 0 var(--space-md) 0;\n}\n\n/* Responsive welcome title sizing */\n@media (min-width: 48rem) { /* 768px */\n  .welcome-title {\n    font-size: 2.5rem; /* 40px */\n  }\n}\n\n@media (min-width: 64rem) { /* 1024px */\n  .welcome-title {\n    font-size: 2.875rem; /* 46px */\n  }\n}\n\n@media (min-width: 90rem) { /* 1440px */\n  .welcome-title {\n    font-size: 3.375rem; /* 54px */\n  }\n}\n\n.welcome-subtitle {\n  font-size: 1.1rem; /* 16px */\n  font-weight: 300 !important;\n  font-style: normal;\n  line-height: 115%;\n  text-align: center;\n  color: var(--color-secondary);\n  margin: 0;\n}\n\n/* Responsive welcome subtitle sizing */\n@media (min-width: 48rem) { /* 768px */\n  .welcome-subtitle {\n    font-size: 1.125rem; /* 18px */\n  }\n}\n\n@media (min-width: 64rem) { /* 1024px */\n  .welcome-subtitle {\n    font-size: 1.25rem; /* 20px */\n  }\n}\n\n@media (min-width: 90rem) { /* 1440px */\n  .welcome-subtitle {\n    font-size: 1.375rem; /* 22px */\n  }\n}\n\n/* Login Form Card */\n.login-form-card {\n  width: 100%;\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-lg);\n}\n\n/* Login Button */\n.login-button {\n  width: 100%;\n  margin-top: var(--space-sm);\n}\n\n/* Forgot Password */\n.forgot-password {\n  text-align: center;\n  margin-top: var(--space-sm);\n}\n\n.forgot-password-link {\n  font-size: var(--font-size-base);\n  font-weight: 500;\n  font-style: normal;\n  line-height: 140%;\n  letter-spacing: 0.03em;\n  text-align: right;\n  vertical-align: middle;\n  color: var(--color-secondary-text);\n  text-decoration: none;\n  transition: color 0.2s ease;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n}\n\n.forgot-password-link:hover {\n  color: var(--color-primary);\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
